<template>
  <div class="bottom-section">
    <div class="bottom-section__item">
      <h2>
        Mau kirim paket tapi males keluar rumah?<br>Cobain <span>Pick-up sekarang!</span>
      </h2>
    </div>
    <div class="bottom-section__btn">
      <Button
        id="btn_kirim_sekarang_new"
        text="Kirim sekarang"
        type-class="indigo-dark"
        img="ics_o_box.svg"
        :round="true"
        :route-to="{ path: '/dropoff-order/sender' }"
      />
    </div>
  </div>
</template>
      
<script>
import Button from "@/components/new-button/Button.vue";

export default {
  name: "BottomSection",
  components: { Button },
}
</script>
    
<style lang="scss" scoped>
@import "@/assets/css/style";
@import "@/assets/css/animation";

.bottom-section {
  display: flex;
  flex-direction: column;
  justify-content: center;
  background-image: url('@/assets/new-home/bg-bottom-section.png');
  background-repeat: no-repeat;
  background-size: cover;
  height: 720px;

  @include for-size(mobile) {
    height: 400px;
    background-image: url('@/assets/new-home/bg-bottom-section-mobile.png');
  }

  &__item {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 0 120px;
    margin-bottom: 60px;
    width: 100%;
    max-width: 1200px;
    margin: 0px auto 40px auto;

    @include for-size(mobile) {
      padding: 10px 0px;
      width: 70%;
      margin: 0 auto;
      display: block;
    }

    @include for-size(tablet-portrait) {
      padding: 0 60px;
    }

    @include for-size(tablet-landscape-new) {
      padding: 0 60px;
    }

    &:nth-child(1) {
      @include for-size(mobile) {
        padding: 10px 0px;
      }

      h2 {
        &:nth-child(1) {
          margin: auto;
          display: block;
          color: $color-indigo-dark;
          font-weight: 700;
          font-size: 48px;
          line-height: 56px;
          text-align: center;

          @include for-size(tablet-portrait) {
            font-size: 32px;
            line-height: 40px;
          }

          @include for-size(tablet-landscape-new) {
            font-size: 42px;
            line-height: 48px;
          }

          span {
            color: $color-red-5;
          }

          @include for-size(mobile) {
            font-size: 24px;
            line-height: 28px;
            text-align: center;
          }
        }

        &:nth-child(2) {
          cursor: pointer;
          color: $color-base;
          font-size: 16pt;
          line-height: 24px;

          @include for-size(mobile) {
            font-weight: 600;
            font-size: 12pt;
            line-height: 21pt;
          }
        }
      }
    }
  }

  &__btn {
    width: 223px;
    margin: 0 auto;

    > a {
      height: 62px;
      display: flex;
      justify-content: center;
      font-size: 20px;
      line-height: 24px;
      font-weight: 600;

      &::v-deep div {
        display: flex !important;
        gap: 10px !important;

        img {
          padding-right: 0px !important;
          width: 28px;

          @include for-size(mobile) {
            width: 20px;
          }
        }
      }
    }

    @include for-size(mobile) {
      width: auto;
      margin-top: 20px;

      > a {
        height: 49px;
        font-size: 14px;
        line-height: 17px;
      }
    }
  }
}
</style>
